import { type Action } from '@jack-henry/frontend-utils/types';
import { noOp } from '@treasury/utils';
import { css, html, type TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-action-tile';
@customElement(tagName)
export class TmActionTile extends TmBaseComponent {
    @property({ type: String })
    public tileTitle = '';

    @property({ type: Object })
    public icon: TemplateResult<2> | undefined;

    @property({ type: Function })
    public action?: Action;

    @property({ type: Boolean })
    public disabled = false;

    protected render() {
        return html`
            <button
                class="w-20 h-full mx-1 border border-[--button-border] rounded-lg text-white"
                @click=${() => (this.action ? this.action() : noOp)}
                ?disabled=${this.disabled}
            >
                <div class="flex flex-col items-center h-full py-2">
                    <div class="w-9 h-9">${this.icon}</div>
                    <div
                        class="flex flex-col justify-center min-h-[26px] px-1 text-xs leading-[13px]"
                    >
                        ${this.tileTitle}
                    </div>
                </div>
            </button>
        `;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --brand-gradient: color-mix(in srgb, var(--brand-primary) 85%, white);
                    --button-background: linear-gradient(
                        149deg,
                        var(--brand-gradient) -1.5%,
                        var(--brand-primary) 89%
                    );
                    --button-border: rgba(255, 255, 255, 0.2);
                }
                :host([theme='dark']) {
                    --button-background: var(--brand-primary-darker);
                    --button-border: rgba(255, 255, 255, 0.1);
                }
                svg {
                    width: 100%;
                    height: auto;
                }
                button {
                    background: var(--button-background, --brand-primary);
                    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
                }
                button[disabled] {
                    opacity: 0.4;
                    pointer-events: none;
                    cursor: not-allowed;
                }
                button path {
                    fill: var(--jh-color-gray-0);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmActionTile;
    }
}
